import { Controller } from '@hotwired/stimulus'
import { scroll } from 'motion'

export default class extends Controller<SVGSVGElement> {
  private cancels: Array<VoidFunction> = []

  override connect() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const mark = this.element
    this.cancels.push(
      scroll(
        (progress: number) => {
          mark.style.setProperty('--arc-draw', (1 - progress).toFixed(4))
        },
        { target: mark, offset: ['start 0.9', 'start 0.5'] },
      ),
      scroll(
        (progress: number) => {
          mark.style.setProperty('--sprout-show', Math.max(0, progress * 2 - 1).toFixed(4))
        },
        { target: mark, offset: ['start 0.8', 'start 0.45'] },
      ),
    )
  }

  override disconnect() {
    for (const cancel of this.cancels.splice(0)) cancel()
  }
}
